export default "__VITE_ASSET__DdA0Yx_B__"